import React, { Component } from "react";
import { debounce } from "lodash";
import { Link, Route, Routes } from "react-router-dom";
import { withRouter, RenderRoute } from "../../utils/router";

import { withRequest } from "../../utils/request";
import Pagination from "../general/Pagination";
import Modal from "../general/Modal";
import Create from "./Create";
import Edit from "./Edit";
import Loader from "../general/Loader";
import { getLink, permisions } from "../../utils/helpers";
import { auth } from "../../utils/auth";

const queryDeFiltros = (filtros) =>
    Object.keys(filtros)
        .map((fil) => `${fil}=${filtros[fil]}`)
        .join("&");

class Rutas extends Component {
    state = {
        rutas: [],
        ruta: {},
        links: null,
        meta: null,
        showCreate: false,
        showEdit: false,
        loading: true,
        filtros: {
            buscar: "",
        },
    };
    componentDidMount() {
        this.getRutas();
    }
    getRutas = async (url = null) => {
        url = url ? url + "&limit=20" : "rutas?limit=20";
        const rutas = await this.props.request(url);
        if (rutas.links) {
            this.setState({
                rutas: rutas.data,
                links: rutas.links,
                meta: rutas.meta,
                loading: false,
            });
        }
    };
    toggleCreateModal = () => {
        this.setState({
            showCreate: !this.state.showCreate,
            ruta: { operadores: [] },
        });
    };
    toggleEditModal = (ruta) => {
        this.setState({
            showEdit: !this.state.showEdit,
            ruta: ruta,
        });
        this.props.history.push(getLink("/rutas"));
    };
    // `await this.setState()` no espera al re-render: setState no devuelve una
    // promesa, así que la continuación se reanudaba antes de que React
    // aplicara el update y `this.state.filtros` tenía los filtros anteriores.
    // Por eso cada consulta salía un filtro atrás y el primer intento no
    // filtraba nada. El estado se actualiza con la forma funcional y la consulta
    // se lanza en el callback de setState, que sí corre después del commit.
    onFiltroChange = (value, filtro) => {
        this.setState((state) => {
            const filtros = { ...state.filtros, [filtro]: value };

            return { filtros };
        }, this.buscarConFiltros);
    };
    // El debounce va sobre la petición, no sobre el cambio de filtro: `debounce`
    // era uno solo para todos los campos, y cambiar dos filtros en menos de 500ms
    // descartaba el primero junto con su valor.
    buscarConFiltros = debounce(() => {
        const query = queryDeFiltros(this.state.filtros);

        this.getRutas("rutas?limit=20&" + query);
    }, 500);
    render() {
        const { rutas, loading } = this.state;
        return (
            <div className='container'>
                <div className='page-header'>
                    <Link to={getLink("/contactos")}>« Volver a contactos</Link>
                    <h1 className='page-title row'>
                        <span className='col'>Todas las Zonas</span>
                        {auth.can(permisions.reporteZonas) && <Link
                            to={getLink(`/imprimir/rutas?limit=200`)}
                            target='_blank'
                            className='au-btn-filter m-r-15'>
                            <i className='zmdi zmdi-print' /> Imprimir
                        </Link>}
                        <button
                            className='au-btn au-btn-icon au-btn--green au-btn--small'
                            onClick={this.toggleCreateModal}>
                            <i className='zmdi zmdi-plus' />
                            Añadir Zona
                        </button>
                    </h1>
                    <div className='page-controls'>
                        <div className='table-data__tool'>
                            <div className='table-data__tool-left row'>
                                <div className='col-md-12'>
                                    <input
                                        onChange={(e) =>
                                            this.onFiltroChange(
                                                e.target.value,
                                                "buscar"
                                            )
                                        }
                                        type='search'
                                        placeholder='Buscar...'
                                        className='form-control'
                                        name='buscar'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div>
                            {loading && <Loader />}
                            {!rutas.length ? (
                                <div>
                                    {!loading && (
                                        <div>No hay zonas creadas.</div>
                                    )}
                                </div>
                            ) : (
                                <div className='table-data'>
                                    <table className='table table-data2'>
                                        <thead>
                                            <tr>
                                                <th>Zona</th>
                                                <th>Sector</th>
                                                <th>Descripción</th>
                                                <th />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rutas.map((ruta) => (
                                                <tr
                                                    className='tr-shadow'
                                                    key={ruta.id}>
                                                    <td>{ruta.nombre}</td>
                                                    <td>{ruta.sector}</td>
                                                    <td>{ruta.descripcion}</td>
                                                    <td>
                                                        <div className='table-data-feature'>
                                                            <Link
                                                                to={getLink(
                                                                    `/rutas/${ruta.id}`
                                                                )}
                                                                className='item'
                                                                data-toggle='tooltip'
                                                                data-placement='top'
                                                                title=''
                                                                data-original-title='Edit'
                                                                onClick={() => {
                                                                    this.toggleEditModal(
                                                                        ruta
                                                                    );
                                                                }}>
                                                                <i className='zmdi zmdi-edit' />
                                                            </Link>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {this.state.links && (
                                        <Pagination
                                            links={this.state.links}
                                            meta={this.state.meta}
                                            getData={this.getRutas}
                                        />
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <Routes>
                    <Route
                        path=':id'
                        element={<RenderRoute render={(props) => (
                            <Modal show blank toggle={this.toggleEditModal}>
                                <Edit
                                    toggle={this.toggleEditModal}
                                    ruta={
                                        rutas.filter(
                                            (r) =>
                                                r.id ===
                                                parseInt(props.match.params.id)
                                        )[0] || {}
                                    }
                                    getRutas={this.getRutas}
                                />
                            </Modal>
                        )} />}
                    />
                </Routes>
                <Modal
                    show={this.state.showCreate}
                    blank={true}
                    toggle={this.toggleCreateModal}>
                    <Create
                        toggle={this.toggleCreateModal}
                        ruta={this.state.ruta}
                        getRutas={this.getRutas}
                    />
                </Modal>
            </div>
        );
    }
}

export default withRouter(withRequest(Rutas));
